/**
 * Client-side registry mirror (enabled providers for UI / requests).
 * Server has the authoritative executable registry.
 */

/** Client mirror — live model/key status comes from GET /api/admin/provider-settings. */
const providers = [
  {
    id: 'openai',
    label: 'OpenAI Images',
    enabled: true,
    defaultModel: 'gpt-image-2.5-sunburst',
    api: 'images.generate',
  },
];

export function listProviders() {
  return providers.slice();
}

export function getProvider(id) {
  return providers.find((p) => p.id === id) || null;
}

export function getDefaultProvider() {
  return providers.find((p) => p.enabled) || null;
}
